<template>
  <div class="mx-auto">
    <v-card height="350">
      <v-card-title>
        符文推荐
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>

        <div v-for="(item,index) in heroInfo.rune" :key="index" class="rune-primary-wrap">
          <div class="rune-item">
            <div v-for="(r,i) in item.src" :key="i"
                 :class="i === 0 || i === 1 || i === 5 ? '' : 'hidden-md-and-down'">

              <v-tooltip top color="#161a20">
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                      v-bind="attrs"
                      v-on="on"
                      :size="i === 0 || i === 1 || i === 5 ? 40 : 30"
                  >
                    <v-img :src="r.img" :max-width="i === 0 || i === 1 || i === 5 ? 40 : 30"
                           :max-height="i === 0 || i === 1 || i === 5 ? 40 : 30"></v-img>
                  </v-avatar>
                </template>
                <div>
                  <span class="pa-3" style="color:#b59758;">{{ r.name }}</span>
                  <v-divider light></v-divider>
                  <div class="pa-3" v-html="r.description"></div>
                </div>
              </v-tooltip>
            </div>
          </div>

          <div class="onstage-chance">
            <span style="color:#1dbaa9;">{{ item.appearanceRate }}%</span>
            <div>登场率</div>
          </div>

          <div class="win-chance">
            <span style="color:#9c8250;">{{ item.winRate }}%</span>
            <div>胜率</div>
          </div>
        </div>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Rune",
  props: {
    heroInfo: {
      type: Object,
      default: () => {
      }
    }
  }
}
</script>

<style scoped>

.rune-primary-wrap {
  width: 100%;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}

.rune-item {
  display: inline-flex;
  align-items: flex-end;
  margin: 5px;
}

.onstage-chance {
  width: 20%;
  text-align: center;
}

.win-chance {
  width: 20%;
  text-align: center;
}

</style>
